import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=2b39e623&scoped=true"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"
import style0 from "./Unit.vue?vue&type=style&index=0&id=2b39e623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39e623",
  null
  
)

export default component.exports